export const COMMENT_ITEM_TEST_ID = 'deep-tags-product-comment-item';
export const COMMENT_ITEM_EDITABLE_DIV_TEST_ID = `${COMMENT_ITEM_TEST_ID}-editable-div`;
export const COMMENT_ITEM_NEW_COMMENT_BUTTON_TEST_ID = `${COMMENT_ITEM_TEST_ID}-new-comment-button`;
export const COMMENT_ITEM_SAVE_BUTTON_TEST_ID = `${COMMENT_ITEM_TEST_ID}-save-button`;
